import React from 'react';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';
import { Box, Grid } from '@material-ui/core';
import Member from './Member';

const PromoCodes = ({ data }) => {
  const { travelers, travelDetails, promoCodes } = data;
  const { selectedPlan, policyPrices, prices, isFetchingPrice } = travelDetails;
  const policyPrice = policyPrices[selectedPlan];
  const discountedPrices = policyPrice && policyPrice.discountedPrices;
  if (!travelers || travelers.length === 0) {
    return <div>-</div>;
  }

  return (
    <Grid container alignItems="center">
      <Grid item xl={12} style={{ width: '100%' }}>
        <Box sx={{ mt: '1rem' }}>
          {travelers.map((traveler) => {
            const discountedPrice = discountedPrices && discountedPrices[traveler.passport];
            const isExistPromoCodes = !isUndefined(promoCodes) && Object.keys(promoCodes).length;
            const promoCode = isExistPromoCodes
              ? promoCodes.find((pc) => pc.memberId === traveler.memberId)
              : null;
            const errorMessage = discountedPrice && discountedPrice.errorMessage;

            return (
              <Member
                key={traveler.memberId}
                traveler={traveler}
                promoCode={promoCode}
                discountedPrice={discountedPrice}
                isFetchingPrice={isFetchingPrice}
                prices={prices}
                selectedPlan={selectedPlan}
                errorMessage={errorMessage}
              />
            );
          })}
        </Box>
      </Grid>
    </Grid>
  );
};

PromoCodes.propTypes = {
  data: PropTypes.shape({
    travelers: PropTypes.arrayOf(PropTypes.shape({})),
    travelDetails: PropTypes.shape({
      selectedPlan: PropTypes.string,
      policyPrices: PropTypes.shape({}),
      prices: PropTypes.shape({}),
      isFetchingPrice: PropTypes.bool,
    }),
    promoCodes: PropTypes.arrayOf(
      PropTypes.shape({
        policyNumber: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default PromoCodes;
